import { apiFetch } from "../apiFetch";

/** A relation attribute as returned by GET /page-schema/content-types. */
export interface SchemaRelation {
  name: string;
  target: string | null;
  relationType: string | null;
}

/** A scalar field as returned by GET /page-schema/content-types. */
export interface SchemaField {
  name: string;
  type: string;
  required: boolean;
}

/** One content-type's introspected shape. */
export interface SchemaContentType {
  uid: string;
  apiName: string | null;
  displayName: string;
  pluralName: string | null;
  fields: SchemaField[];
  relations: SchemaRelation[];
}

/**
 * Fetch the project's content-type schema from the read-only introspection endpoint.
 * Shared by the builder (dropdown options) and the renderer (uid -> REST pluralName).
 */
export async function fetchContentTypes(): Promise<SchemaContentType[]> {
  const res = await apiFetch(`/page-schema/content-types`);
  if (!res.ok) throw new Error(`Failed to load content-type schema (${res.status})`);
  return (await res.json()) as SchemaContentType[];
}

/** Resolve a content-type uid to its REST plural endpoint name using the schema. */
export function pluralNameFor(schema: SchemaContentType[], uid: string): string | null {
  const ct = schema.find((c) => c.uid === uid);
  return ct?.pluralName ?? null;
}
